import { Component, OnInit, ViewChild } from "@angular/core";
import { DatePipe, DecimalPipe } from "@angular/common";
import { ExportExcelService } from "../../shared/services/export-excel.service";
import { ActivatedRoute } from "@angular/router";
import { CommonDataService } from "../../shared/services/common-data.service";
import { IMyOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { MatAutocompleteSelectedEvent } from '@angular/material';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map , startWith} from 'rxjs/operators'
import * as moment from 'moment';
import { hrtime } from 'process';
import { From_date, To_date} from  '@root/app.constant';


@Component({
  selector: "app-nav-dividends",
  templateUrl: "./nav-dividends.component.html",
  styleUrls: ["./nav-dividends.component.scss"],
})
export class NavDividendsComponent implements OnInit {
  
  noData : string;

  today = new Date();

  schemeControl = new FormControl({'scheme':'All'});

  public myDatePickerOptionsFrom: IMyOptions = {
    dateFormat: "dd mmm yyyy",
    editableDateField: false,
  };
  public myDatePickerOptionsTo: IMyOptions = {
    dateFormat: "dd mmm yyyy",
    editableDateField: false,
  };

  activeTab = "nav";

  activeTabSub = "current";

  userData = {
    scheme: "All",
    plan: "All",
    fromDate: new Date().toISOString(),
    toDate: new Date().toISOString(),
  };
  
  planList = [];

  schemeList = [];

  filteredSchemeList: Observable<any[]>;

  data = [];

  constructor(
    public exportExcel: ExportExcelService,
    public route: ActivatedRoute,
    private commonDataService: CommonDataService,
    private toastr: ToastrService,
    public apiService: ApiService
  ) {}

  ngOnInit() {
    this.getScheme();
    this.scrollTop();
    this.setCurrentDate();
    this.schemeControl.valueChanges.subscribe(
      value=>{
        const schemeList = this._filter(value);
        this.filteredSchemeList= new Observable(ob => {ob.next(schemeList); })
      }
    );
  }
  
  private _filter(value: string): any[] {
    let filterValue = '';
    if(value){
      filterValue = value.toLowerCase();
    }
    //const filterValue = value ? value+''.toLowerCase() : '';
    return this.schemeList.filter(item => item.scheme.toLowerCase().includes(filterValue));
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  setCurrentDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const obj = this.getCopyOfOptions(this.myDatePickerOptionsTo);
    obj.disableSince = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
    this.myDatePickerOptionsTo = obj;
    this.myDatePickerOptionsFrom = obj;
  };

  public onSchemeChange(event: MatAutocompleteSelectedEvent){
    this.userData.scheme = event.option.value ? event.option.value.scheme : '';
    this.getPlan(this.userData.scheme)
  }

  getScheme = () => {
    let url;
    if (this.activeTab === "nav") {
      url = Urls.getSchemeNav;
    } else {
      url = Urls.getSchemeDiv;
    }
    this.apiService.getData(url).subscribe((response: any) => {
      const schemeList = response.data.schemeList; 
      this.schemeList =  [{scheme: 'All'} , ...schemeList];
      this.filteredSchemeList= new Observable(ob => {ob.next(this.schemeList); })
      this.getPlan(this.userData.scheme);
    });
  };

  getPlan = (scheme:string ) => {
    let url;
    if (this.activeTab === "nav") {
      url = Urls.getPlanNav;
    } else {
      url = Urls.getPlanDiv;
    }
    const _scheme = scheme ? scheme : 'All';
    this.apiService.postData(url, {"scheme": _scheme}).subscribe((response: any) => {
      const planList = response.data.planList;
      this.planList = [{'plan': 'All'}, ...planList]
      this.getTableData();
    });
  };

  getTableData = () => {
    let url;
    if (this.activeTab === "nav") {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentNav;
      } else {
        url = Urls.getHistoricNav;
      }
    } else {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentDividend;
      } else {
        url = Urls.getHistoricDividend;
      }
    }

    if (this.activeTabSub === "current") {
      delete this.userData.fromDate;
      delete this.userData.toDate;
    } 

    const requestData = JSON.parse(JSON.stringify(this.userData));

    if (this.userData.plan === "All") {
      requestData.plan = "";
    }
    if (this.userData.scheme === "All") {
      requestData.scheme = "";
    }
    
    this.apiService.postData(url, requestData).subscribe((response: any) => {
      this.data = response.data.returnList;
    });
  };

  setActive = (val) => {
    this.resetData();
    this.activeTab = val;
    this.getScheme();
    this.getTableData();
  };

  setActiveSub = (val) => {
    this.resetData();
    this.activeTabSub = val;
    this.getTableData();
  };

  onDateChanged = (event, val) => {
    let date = new Date(event.jsdate);
    if (event.jsdate === null) {
      date = new Date();
    }
    date.setDate(date.getDate() - 1);
    if (val === "from") {
      const obj = this.getCopyOfOptions(this.myDatePickerOptionsTo);
      obj.disableUntil = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
      this.myDatePickerOptionsTo = obj;
    } else {
      date.setDate(date.getDate() + 1);
      const obj = this.getCopyOfOptions(this.myDatePickerOptionsFrom);
      obj.disableSince = {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      };
      this.myDatePickerOptionsFrom = obj;
    }
  };

  getCopyOfOptions(val): IMyOptions {
    return JSON.parse(JSON.stringify(val));
  }

  getCustomMonth = (val) => {
    const month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    const parseDate = new Date(val);
    return (
      parseDate.getDate() +
      " " +
      month[parseDate.getMonth()] +
      " " +
      parseDate.getFullYear()
    );
  };

  public downloadXls() {
    const data = this.getFormatedData();
    this.exportExcel.exportAsExcelFile(
      data,
      `Latest_${this.activeTab}_${this.activeTabSub}`
    );
  }

  private getFormatedData(): any[] {
    const datePipe = new DatePipe("en-US");
    const decimalPipe = new DecimalPipe("en-US");

    const data = JSON.parse(JSON.stringify(this.data));
    for (const row of data) {
      if (row.date) {
        row.date = datePipe.transform(row.date, "dd MMM yyyy");
      }
      if (row.currentNav) {
        const currentNav = decimalPipe.transform(row.currentNav, "1.4-4");
        row.currentNav = `₹ ${currentNav}`;
      }
      if (row.previousNav) {
        const previousNav = decimalPipe.transform(row.previousNav, "1.4-4");
        row.previousNav = `₹ ${previousNav}`;
      }
      /*Divedents */
      if (row.recordDate) {
        row.recordDate = datePipe.transform(row.recordDate, "dd MMM yyyy");
      }
      if (row.corporate) {
        const corporate = row.corporate
        row.corporate = `₹ ${corporate}`;
      }
      if (row.individual) {
        const individual = row.individual
        row.individual = `₹ ${individual}`;
      }
      if (row.percentage) {
        const percentage = decimalPipe.transform(row.percentage, "1.2-2");
        row.percentage = `${percentage}`;
      }
       if (row.change) {
       const change = row.change;
         row.change = `₹ ${change}`;
       }
    }
    return data;
  }

  resetData = () => {
    this.userData.scheme = "All";
    this.userData.plan = "All";
    this.userData.fromDate = "";
    this.userData.toDate = "";
      this.schemeControl.setValue({scheme: 'All'});
  };

  getTableDataSubmit = () => {
    let url;
    if (this.activeTab === "nav") {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentNav;
      } else {
        url = Urls.getHistoricNav;
      }
    } else {
      if (this.activeTabSub === "current") {
        url = Urls.getCurrentDividend;
      } else {
        url = Urls.getHistoricDividend;
      }
    }

    if (this.activeTabSub === "current") {
      delete this.userData.fromDate;
      delete this.userData.toDate;
    } else {
      if (!this.userData.fromDate) {
        this.toastr.error(From_date);
        return;
      }
      if (!this.userData.toDate ) {
        this.toastr.error(To_date);
        return;
      }
    }
    
    if(this.userData.fromDate){
      this.userData.fromDate = moment(this.userData.fromDate).set('hour', 12).toISOString();
    }
    if(this.userData.toDate){
      this.userData.toDate = moment(this.userData.toDate).set('hour', 12).toISOString();
    }
    const requestData = JSON.parse(JSON.stringify(this.userData));
    if (this.userData.plan === "All") {
      requestData.plan = "";
    }
    if (this.userData.scheme === "All") {
      requestData.scheme = "";
      this.userData.plan = "All"
    }
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(url, requestData).subscribe(
      response => {
        if(response.status === 0){
          this.data = response.data.returnList;
          this.commonDataService.loaderStatus.next(false);
        }
      },
      error => {
        if(error.status === -1){
          this.data = [];
          this.commonDataService.loaderStatus.next(false);
        }
      }
    )
  };

  displayFn(item?: any): string | undefined {
    return item ? item.scheme : undefined;
  }

  showAllScheme() {
    this.filteredSchemeList= new Observable(ob => {ob.next(this.schemeList); })
  }
}
